import { render, staticRenderFns } from "./RankingSettingSection.vue?vue&type=template&id=61f74372&scoped=true"
import script from "./RankingSettingSection.vue?vue&type=script&lang=ts"
export * from "./RankingSettingSection.vue?vue&type=script&lang=ts"
import style0 from "./RankingSettingSection.vue?vue&type=style&index=0&id=61f74372&prod&lang=scss&scoped=true"
import style1 from "./RankingSettingSection.vue?vue&type=style&index=1&id=61f74372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f74372",
  null
  
)

export default component.exports